import { motion } from "framer-motion";
import { PRICE_INR, PRODUCT_HERO_IMAGE } from "@/lib/config";
import { useLang } from "@/lib/LanguageContext";
import QuickOrder from "@/components/QuickOrder";

export default function OrderForm() {
    const { t } = useLang();
    const trust = t("order.trust") || [];

    return (
        <section
            id="order"
            className="py-24 md:py-40 bg-[#F9F6F0]"
            data-testid="order-section"
        >
            <div className="container-x">
                <div className="grid grid-cols-12 gap-10 md:gap-16 items-start">
                    <motion.div
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.9, ease: [0.19, 1, 0.22, 1] }}
                        className="col-span-12 lg:col-span-5"
                    >
                        <div className="chapter-num mb-4">{t("order.chapter")}</div>
                        <h2 className="font-serif text-5xl md:text-6xl lg:text-7xl text-[#2D2824] tracking-[-0.02em] leading-[0.98]">
                            {t("order.title_1")}
                            <br />
                            <em className="italic text-[#B48F57]">
                                {t("order.title_2_em")}
                            </em>
                        </h2>

                        <div className="mt-10 border-t border-[#D9D1C7] pt-8">
                            <div className="flex items-baseline justify-between">
                                <span className="eyebrow text-[#5C564D]">
                                    {t("order.pack_label")}
                                </span>
                                <span className="font-serif text-2xl text-[#2D2824]">
                                    {t("order.pack_value")}
                                </span>
                            </div>
                            <div className="mt-4 flex items-baseline justify-between">
                                <span className="eyebrow text-[#5C564D]">
                                    {t("order.price_label")}
                                </span>
                                <span
                                    className="font-serif text-4xl md:text-5xl text-[#2D2824]"
                                    data-testid="order-price"
                                >
                                    ₹{PRICE_INR.toLocaleString("en-IN")}
                                </span>
                            </div>
                            <div className="mt-4 flex items-baseline justify-between">
                                <span className="eyebrow text-[#5C564D]">
                                    {t("order.shipping_label")}
                                </span>
                                <span className="text-[#2D2824]">
                                    {t("order.shipping_value")}
                                </span>
                            </div>
                        </div>

                        <div className="relative mt-12 spotlight">
                            <img
                                src={PRODUCT_HERO_IMAGE}
                                alt="VARDHAN pack"
                                className="relative z-10 w-full max-w-[440px] object-contain drop-shadow-[0_25px_45px_rgba(45,40,36,0.18)]"
                                loading="lazy"
                                data-testid="order-product-image"
                            />
                        </div>

                        <div className="mt-10 grid grid-cols-2 gap-x-6 gap-y-3">
                            {trust.map((b, i) => (
                                <div
                                    key={i}
                                    className="flex items-center gap-3 text-[12px] tracking-[0.14em] uppercase text-[#5C564D]"
                                    data-testid={`trust-${i}`}
                                >
                                    <span className="block w-2 h-2 rotate-45 bg-[#B48F57]" />
                                    {b}
                                </div>
                            ))}
                        </div>
                    </motion.div>

                    <div className="col-span-12 lg:col-span-7 lg:pt-4">
                        <QuickOrder />
                    </div>
                </div>
            </div>
        </section>
    );
}
